import { render, staticRenderFns } from "./SearchCollection.vue?vue&type=template&id=70e3df58"
import script from "./SearchCollection.vue?vue&type=script&lang=js"
export * from "./SearchCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports